module.exports = __webpack_public_path__ + "assets/fingerprintjs.e24bca2c.svg";